import React, { useState } from 'react'
import "./Faq.css"


const Faq = () => {
    const[toggle1, setToggle1] = useState(true)
    const[toggle2, setToggle2] = useState(true)
    const[toggle3, setToggle3] = useState(true)
    const[toggle4, setToggle4] = useState(true)
    const[toggle5, setToggle5] = useState(true)
    const[toggle6, setToggle6] = useState(true)

    const handleToggle1 = () => {
        setToggle1(!toggle1)
    }
    const handleToggle2 = () => {
        setToggle2(!toggle2)
    }
    const handleToggle3 = () => {
        setToggle3(!toggle3)
    }
    const handleToggle4 = () => {
        setToggle4(!toggle4)
    }
    const handleToggle5 = () => {
        setToggle5(!toggle5)
    }
    const handleToggle6 = () => {
        setToggle6(!toggle6)
    }


  return (
    <div className='mainContainer1'>
        <div style={{display: 'flex'}}>
            <h4 >Frequently Asked Question</h4>             
        </div>

        <div className='headContainer1'>
            <div className='headIcon1'>
                <i onClick={handleToggle1} class={toggle1 ? "fa-solid fa-plus" : "fa-solid fa-minus" }></i>
                <h1 onClick={handleToggle1}>What are the key highlights of the tour package?</h1>
            </div>
            <div className='para1' style={{display : toggle1 ? "none": "block"}}>
                <p>Our tour package includes visits to iconic landmarks, cultural experiences, and adventurous activities. Highlights vary by destination but may include guided tours, local cuisine tastings, and opportunities for relaxation.</p>
            </div>
        </div>

        <div className='headContainer1'>
            <div className='headIcon1'>
                <i onClick={handleToggle2} class={toggle2 ? "fa-solid fa-plus" : "fa-solid fa-minus" }></i>
                <h1 onClick={handleToggle2}>Can you provide information about accommodation and transportation?</h1>
            </div>
            <div className='para1' style={{display : toggle2 ? "none": "block"}}>
                <p>FAccommodations typically range from well-appointed hotels to comfortable resorts, depending on the package. Transportation is carefully arranged, often including flights, ground transfers, and local transportation for excursions.</p>
            </div>
        </div>

        <div className='headContainer1'>
            <div className='headIcon1'>
                <i onClick={handleToggle3} class={toggle3 ? "fa-solid fa-plus" : "fa-solid fa-minus" }></i>
                <h1 onClick={handleToggle3}>What is the total cost of the tour, and what is included?</h1>
            </div>
            <div className='para1' style={{display : toggle3 ? "none": "block"}}>
                <p>The total cost varies based on the destination and package chosen. It covers accommodation, specified meals, transportation, guided tours, and entrance fees to attractions. Additional expenses may include personal purchases and optional activities.</p>
            </div>
        </div>

        <div className='headContainer1'>
            <div className='headIcon1'>
                <i onClick={handleToggle4} class={toggle4 ? "fa-solid fa-plus" : "fa-solid fa-minus" }></i>
                <h1 onClick={handleToggle4}>How does the booking process work?</h1>
            </div>
            <div className='para1' style={{display : toggle4 ? "none": "block"}}>
                <p>YTo book a tour, you can visit our website or contact our representatives. We'll need basic information such as the number of travelers, preferred dates, and any specific preferences. A deposit is typically required to secure your reservation.</p>
            </div>
        </div>

        <div className='headContainer1'>
            <div className='headIcon1'>
                <i onClick={handleToggle5} class={toggle5 ? "fa-solid fa-plus" : "fa-solid fa-minus" }></i>
                <h1 onClick={handleToggle5}> What is your cancellation policy?</h1>
            </div>
            <div className='para1' style={{display : toggle5 ? "none": "block"}}>
                <p>Tour cancellation policy is designed to be fair to both travelers and the agency. Cancellation fees may apply, and they vary depending on how far in advance the cancellation occurs. We recommend reviewing the specific terms outlined in our booking agreement.</p>
            </div>
        </div>

        <div className='headContainer1'>
            <div className='headIcon1'>
                <i onClick={handleToggle6} class={toggle6 ? "fa-solid fa-plus" : "fa-solid fa-minus" }></i>
                <h1 onClick={handleToggle6}>How can I reach the agency during the tour in case of emergencies?</h1>
            </div>
            <div className='para1' style={{display : toggle6 ? "none": "block"}}>
                <p>We provide a 24/7 helpline for emergencies. You will be given contact information and clear instructions on how to reach our support team during the tour. Additionally, our local guides are trained to assist with any immediate concerns you may have.</p>
            </div>
        </div>
    </div>
   
  )
}

export default Faq